// extracted by mini-css-extract-plugin
export default {"characteristick":"product_characteristick__iprUo"};